import React from "react"
import supabase from "../../utils/subabaseClient"
import { useAuth } from "../../Contexts/AuthContext"


export default function useData(id) {
  const { user } = useAuth()

  const [name, setName] = React.useState("")
  const [description, setDescription] = React.useState("")
  const [members, setMembers] = React.useState([])
  const [group, setGroup] = React.useState({})
  const [loading, setLoading] = React.useState(false)

  const createGroup = async () => {
    const { data, error } = await supabase
      .from("expense_groups")
      .insert({
        name,
        description,
        created_by: (user).id,
        members: members.map((member) => member.auth_user_id),
      })
      .select()

    if (error) {
      console.error("Error creating expense group:", error.message)
    } else {
      console.log("Expense group created successfully!")
      window.location.href = "/expense-groups"
      setGroup(data)
    }
  }

  const updateGroup = async () => {
    const { data, error } = await supabase
      .from("expense_groups")
      .update({ name, description })
      .eq("id", id)
      .select()

    if (error) {
      console.error("Error updating expense group:", error.message)
    } else {
      console.log("Expense group updated successfully!")
      window.location.href = "/expense-groups"
      setGroup(data)
    }
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    setLoading(true)
    if (id) {
      updateGroup()
    } else {
      createGroup()
    }
    setLoading(false)
  }

  const fetchExpenseGroup = async () => {
    const { data, error } = await supabase
      .from("expense_groups")
      .select("*")
      .eq("id", id)
      .single()

    if (error) {
      console.error("Error fetching expense group:", error.message)
    } else {
      console.log("Expense group fetched successfully!")
      setName(data?.name)
      setDescription(data?.description)
      setGroup(data)
    }
  }

  React.useEffect(() => {
    if (id) {
      fetchExpenseGroup()
    }
  }, [id])

  return {
    name,
    setName,
    description,
    setDescription,
    members,
    setMembers,
    handleSubmit,
    loading,
    group,
  }
}
